module.exports = __webpack_public_path__ + "a6f86de48c05d8edc800c2406416f70e.MP3";